// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: '',
  SERVER_URL: 'http://dev.admin.cd.cge.dhltd.corp',
  hangfireEndpoint: 'http://mrkregwwvwdv01.dhltd.corp/',
  inputfileEndpoint: 'http://10.64.72.50/',
  apiEndpoint: 'https://localhost:44340',
  production: true,
  useHash: true,
  hmr: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
